const FtaInformationConst = {
    FtaInformationFolder: [
        {
            folder: "RCEP重要资料和法规",
            files: [
                "RCEP协定正文-中文版.pdf",
                "RCEP协定正本-英文版.pdf",
                "RCEP原产地规则.pdf",
                "RCEP原产地证书背页填制说明.pdf",
                "RCEP特定原产地规则中文版.pdf",
                "RCEP特定原产地规则英文版.pdf",
                "《中华人民共和国海关〈区域全面经济伙伴关系协定〉项下进出口货物原产地管理办法》.pdf",
                "中华人民共和国海关注册登记和备案企业信用管理办法.pdf",
                "中华人民共和国海关经核准出口商管理办法.pdf",
                "原产地规则附件二-最低信息要求-英文版.pdf",
                "原产地规则附件二-最低信息要求.pdf"
            ]
        },
        {
            folder: "中国-东盟FTA",
            files: [
                "东盟新版证书模板.pdf",
                "中华人民共和国海关《中华人民共和国与东南亚国家联盟全面经济合作框架协议》项下经修订的进出口货物原产地管理办法.pdf",
                "中国东盟FTA原产地操作程序升级版2019年最新.pdf",
                "中国东盟FTA原产地规则升级版2019年最新.pdf",
                "中国东盟FTA特定原产地规则升级版2019年最新.pdf"
            ]
        },
        {
            folder: "中国-智利FTA",
            files: [
                "中华人民共和国海关《中华人民共和国政府和智利共和国政府自由贸易协定》项下进出口货物原产地管理办法.pdf",
                "中国智利自由贸易协定-中文版.pdf",
                "中国智利自贸协定原产地证书格式及背页说明.pdf",
                "中国智利自贸协定特定原产地规则.pdf",
            ]
        },
        {
            folder: "中国-韩国FTA",
            files: [
                "《中华人民共和国政府和大韩民国政府自由贸易协定》项下《特别货物清单》.pdf",
                "中韩协定原产地规则中文版.pdf",
                "中韩协定原产地规则英文版.pdf",
                "中韩协定特定原产地规则中英文版.pdf",
                "中韩特定原产地规则-总体解释性说明.pdf",
                "中韩特定货物境外加工清单.pdf"
            ]
        },
        {
            folder: "中国-澳大利亚FTA",
            files: [
                "中国澳大利亚原产地规则中文版.pdf",
                "中国澳大利亚原产地规则英文版.pdf",
                "中国澳大利亚特定原产地规则中文版.pdf",
                "中国澳大利亚特定原产地规则英文版.pdf",
                "澳大利亚海关实施中澳自贸协定的通知2015-41号.pdf"
            ]
        },
        {
            folder: "自由贸易协定原产地证书填制指南",
            files: [
                "RCEP协定重要原产地规则解析.pdf",
                "中国智利优惠原产地证书申请填制指南-南京市贸促会.pdf",
                "中国澳大利亚优惠原产地证书申请填制指南-南京市贸促会.pdf",
                "中国韩国优惠原产地证书申请填制指南-南京市贸促会.pdf",
                "RCEP优惠原产地证书申请填制指南-海关单一窗口.pdf",
                "中国澳大利亚优惠原产地证书申请填制指南（试行）-海关单一窗口.pdf",
                "中国东盟优惠原产地证书申请填制指南（试行）-海关单一窗口.pdf",
                "中国韩国优惠原产地证书申请填制指南（试行）-海关单一窗口.pdf",
                "中国智利优惠原产地证书申请填制指南（试行）-海关单一窗口.pdf"
            ]
        },
        {
            folder: "企业对外投资国别（地区）营商环境指南",
            files: [
                "企业对外投资国别（地区）营商环境指南-阿根廷（2021）.pdf",
                "企业对外投资国别（地区）营商环境指南-澳大利亚（2021）.pdf",
                "企业对外投资国别（地区）营商环境指南-波黑（2021）.pdf",
                "企业对外投资国别（地区）营商环境指南-斐济（2021）.pdf",
                "企业对外投资国别（地区）营商环境指南-黑山（2021）.pdf",
                "企业对外投资国别（地区）营商环境指南-津巴布韦（2021）.pdf",
                "企业对外投资国别（地区）营商环境指南-肯尼亚（2021）.pdf",
                "企业对外投资国别（地区）营商环境指南-美国（2021）.pdf",
                "企业对外投资国别（地区）营商环境指南-秘鲁（2021）.pdf",
                "企业对外投资国别（地区）营商环境指南-斯洛伐克（2021）.pdf",
                "企业对外投资国别（地区）营商环境指南-坦桑尼亚（2021）.pdf",
                "企业对外投资国别（地区）营商环境指南-文莱（2021）.pdf",
                "企业对外投资国别（地区）营商环境指南-乌兹别克斯坦（2021）.pdf",
                "企业对外投资国别（地区）营商环境指南-新西兰（2021）.pdf",
                "企业对外投资国别（地区）营商环境指南-伊拉克（2021）.pdf"
            ]
        }
    ]
}
export default FtaInformationConst
